import * as yup from 'yup';

const schema = yup.object().shape({
  email: yup.string().email('Invalid email address!').required('Email is required.'),
  code: yup.string().required('Code is required.')
});

export default schema;
